import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { convertPropToCssClassName } from '@elliemae/ds-classnames';
import Group from '@elliemae/ds-shared/GroupContext/Group';
import { TooltipTextProvider } from '@elliemae/ds-truncated-tooltip-text';
import { DSAccordionItem } from './DSAccordionItem.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-icons/ArrowheadRight';
import '@elliemae/ds-icons/ArrowheadDown';
import '@elliemae/ds-shared/GroupContext/GroupItem';
import './DSAccordionHeader.js';
import '@elliemae/ds-system';
import '@elliemae/ds-icons/ChevronDown';
import '@elliemae/ds-icons/ChevronRight';
import '@elliemae/ds-button';
import './DSAccordionHeaderActions.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import './blocks.js';
import './DSAccordionHeaderTitle.js';

var DSAccordion = function DSAccordion(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$activeValue = _ref.activeValue,
      activeValue = _ref$activeValue === void 0 ? '' : _ref$activeValue,
      children = _ref.children,
      _ref$allowMultipleOpe = _ref.allowMultipleOpen,
      allowMultipleOpen = _ref$allowMultipleOpe === void 0 ? false : _ref$allowMultipleOpe,
      _ref$contentExpandabl = _ref.contentExpandable,
      contentExpandable = _ref$contentExpandabl === void 0 ? false : _ref$contentExpandabl,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;

  var _convertPropToCssClas = convertPropToCssClassName('accordion'),
      cssClassName = _convertPropToCssClas.cssClassName;

  var tabsRef = {};

  var handleKeyPress = function handleKeyPress(index, e) {
    if (e.keyCode === 39 || e.keyCode === 40) {
      var nextTab = tabsRef[index + 1];
      if (!nextTab) return;
      tabsRef[index + 1].focus();
    }

    if (e.keyCode === 37 || e.keyCode === 38) {
      var _nextTab = tabsRef[index - 1];
      if (!_nextTab) return;
      tabsRef[index - 1].focus();
    }
  };

  return /*#__PURE__*/React.createElement(TooltipTextProvider, null, /*#__PURE__*/React.createElement(Group, {
    activeValue: activeValue,
    multiple: allowMultipleOpen,
    onChange: onChange
  }, /*#__PURE__*/React.createElement("section", _extends({
    className: cssClassName
  }, containerProps), React.Children.map(children, function (child, idx) {
    return /*#__PURE__*/React.cloneElement(child, {
      key: idx,
      idx: idx,
      expandable: contentExpandable,
      setTabRef: function setTabRef(ref) {
        tabsRef[idx] = ref;
      },
      handleKeyPress: handleKeyPress
    });
  }, null))));
};

var props = {
  /** inject props to wrapper */
  containerProps: PropTypes.object.description('inject props to wrapper'),

  /**
   * Selected default active value
   */
  activeValue: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])), PropTypes.string, PropTypes.number]).description('Selected default active value'),

  /**
   * Accordion items to show
   */
  children: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.instanceOf(DSAccordionItem)
  })).isRequired.description('Accordion items to show'),

  /**
   * Allows multiple accordion items to be open at the same time
   */
  allowMultipleOpen: PropTypes.bool.description('Allows multiple accordion items to be open at the same time'),

  /**
   * Whether content is expandable or not
   */
  contentExpandable: PropTypes.bool.description('Whether content is expandable or not'),

  /**
   * Allows a function that is triggered once the accordion changes
   */
  onChange: PropTypes.func.description('Allows a function that is triggered once the accordion changes')
};
DSAccordion.propTypes = props;
var DSAccordionWithSchema = describe(DSAccordion);
DSAccordionWithSchema.propTypes = props;

export default DSAccordion;
export { DSAccordion, DSAccordionWithSchema };
//# sourceMappingURL=DSAccordion.js.map
